import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

export interface DemoContentLogEntry {
  id: number;
  contentType: 'events' | 'measurements';
  summary: string;
  itemsCount: number;
  createdAt: string;
}

export interface DemoContentAccountDiagnostics {
  userId: number;
  name: string | null;
  email: string | null;
  status: number | null;
  lastEventsAt: string | null;
  lastMeasurementsAt: string | null;
  recentLogs: DemoContentLogEntry[];
}

export interface DemoContentAccountsResponse {
  accounts: DemoContentAccountDiagnostics[];
  passwordHint: string;
}

export const getDemoContentAccounts = async (): Promise<DemoContentAccountsResponse> => {
  const response = await api.get<ApiResponse<DemoContentAccountsResponse>>('/admin/demo-content/accounts');
  return unwrapApiResponse<DemoContentAccountsResponse>(response);
};
